/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompletionData } from './CompletionData';
import {
    CompletionDataFromJSON,
    CompletionDataFromJSONTyped,
    CompletionDataToJSON,
    CompletionDataToJSONTyped,
} from './CompletionData';
import type { ExerciseConfig } from './ExerciseConfig';
import {
    ExerciseConfigFromJSON,
    ExerciseConfigFromJSONTyped,
    ExerciseConfigToJSON,
    ExerciseConfigToJSONTyped,
} from './ExerciseConfig';

/**
 * 
 * @export
 * @interface CompletedExercise
 */
export interface CompletedExercise {
    /**
     * 
     * @type {string}
     * @memberof CompletedExercise
     */
    exerciseId: string;
    /**
     * 
     * @type {ExerciseConfig}
     * @memberof CompletedExercise
     */
    config: ExerciseConfig;
    /**
     * 
     * @type {string}
     * @memberof CompletedExercise
     */
    deckId?: string;
    /**
     * 
     * @type {CompletionData}
     * @memberof CompletedExercise
     */
    completionData: CompletionData;
}

/**
 * Check if a given object implements the CompletedExercise interface.
 */
export function instanceOfCompletedExercise(value: object): value is CompletedExercise {
    if (!('exerciseId' in value) || value['exerciseId'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('completionData' in value) || value['completionData'] === undefined) return false;
    return true;
}

export function CompletedExerciseFromJSON(json: any): CompletedExercise {
    return CompletedExerciseFromJSONTyped(json, false);
}

export function CompletedExerciseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedExercise {
    if (json == null) {
        return json;
    }
    return {
        
        'exerciseId': json['exerciseId'],
        'config': ExerciseConfigFromJSON(json['config']),
        'deckId': json['deckId'] == null ? undefined : json['deckId'],
        'completionData': CompletionDataFromJSON(json['completionData']),
    };
}

export function CompletedExerciseToJSON(json: any): CompletedExercise {
    return CompletedExerciseToJSONTyped(json, false);
}

export function CompletedExerciseToJSONTyped(value?: CompletedExercise | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exerciseId': value['exerciseId'],
        'config': ExerciseConfigToJSON(value['config']),
        'deckId': value['deckId'],
        'completionData': CompletionDataToJSON(value['completionData']),
    };
}

